module.exports = __webpack_public_path__ + "img/card-banner-2.7c9ff003.png";